import { shape, string } from 'prop-types';

export const HERO_CTA = shape({
    headline: string,
    standfirstText: string,
    sellerName: string,
});
